import { LoadingIndicator } from '../components/atoms/LoadingIndicator';
import useStaticImage from '../hooks/useStaticImage';

const LoadingPage = ({
  loadingMessage = 'Loading...',
}: {
  loadingMessage?: string | null;
}) => {
  const backgroundImage = useStaticImage('images/login_background.png');
  const logoImage = useStaticImage('images/login_logo.png');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Modal content */}
      <div className="size-full overflow-auto bg-white p-8">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={backgroundImage}
            alt="Loading Background"
            className="size-full object-cover"
          />
        </div>
        {/* Loading message content  */}
        <div className="mt-20 flex flex-col items-center justify-center space-y-36">
          <img src={logoImage} alt="Logo" className="z-50 flex" />
          <div className="flex flex-col items-center justify-center space-y-6">
            <LoadingIndicator isLoading type="large" color="fill-white" />

            <label className="z-50 text-center text-xl font-bold text-white">
              {loadingMessage}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
